import React, { useEffect } from 'react';
import StockChart from '../components/StockChart';

const StockChartPage = () => {
  useEffect(() => {
    // Load Plotly.js library
    const script = document.createElement('script');
    script.src = 'https://cdn.plot.ly/plotly-latest.min.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <StockChart />
    </div>
  );
};

export default StockChartPage;
